import React from 'react';

import { ReactComponent as Icon } from 'assets/icons/brand-status.svg';
import { FileUploader, Input } from '@cokitchen/cokitchen-components';
import { STORAGE_KEYS } from 'utils/constants';

type ImageUrlsType = {
  event_image: string[];
  cover_images: string[];
  cover_videos: string[];
};
type Props = {
  cokitchenStatus: string;
  setCokitchenStatus: (cokitchenStatus: string) => void;
  imageUrls: ImageUrlsType;
  setImageUrls: (fileUrl: ImageUrlsType) => void;
};

const CokitchenStatus = ({
  cokitchenStatus,
  setCokitchenStatus,
  imageUrls,
  setImageUrls
}: Props) => {
  const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN) as string;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked, value } = e.target;
    if (checked) setCokitchenStatus(value);
  };

  return (
    <div className={`w-full p-[20px] bg-[#F9F6F6] rounded-md`}>
      <div className='flex gap-2 mb-8'>
        <Icon className='text-[#1D0105]' />
        <p className='text-sm text-[#1D0105] font-medium'>Select the status of this brand</p>
      </div>
      <div className='flex gap-[86px]'>
        <div className='flex gap-[8px] items-center'>
          <Input
            type='radio'
            name='cokitchenType'
            checked={cokitchenStatus === 'standard'}
            onChange={handleChange}
            value='standard'
            label='Standard kitchen'
          />
        </div>
        <div className='flex gap-[8px] items-center'>
          <Input
            type='radio'
            name='cokitchenType'
            checked={cokitchenStatus === 'popup'}
            onChange={handleChange}
            label='Pop up kitchen'
            value='popup'
          />
        </div>
        <div className='flex gap-[8px] items-center'>
          <Input
            type='radio'
            name='cokitchenType'
            checked={cokitchenStatus === 'dine_in'}
            onChange={handleChange}
            label='Dine in kitchen'
            value='dine_in'
          />
        </div>
      </div>

      <div>
        <div className='w-full mt-4 p-4 bg-white'>
          <FileUploader
            token={token}
            label={<p className='mb-2'>Upload Image</p>}
            className='w-full'
            fileUrls={imageUrls.event_image}
            setFileUrls={(event_image) => setImageUrls({ ...imageUrls, event_image })}
          />
        </div>
        <div>
          <FileUploader
            key={imageUrls.cover_images.length}
            token={token}
            maxNumberOfFiles={6}
            fileType='image'
            fileUrls={imageUrls.cover_images}
            setFileUrls={(cover_images) => setImageUrls({ ...imageUrls, cover_images })}
            label={
              <div className='mb-4'>
                <h3 className='font-medium text-[16px]'>Upload Display Images </h3>
                <p className='text-[10px] text-[#595959] mt-1'> Maximum of 6 images</p>
              </div>
            }
            isMultiple
            disabled={imageUrls.cover_images.length >= 6}
            className='mt-5'
          />
          {imageUrls.cover_images.length > 0 && (
            <div className='mt-4 flex flex-wrap gap-3'>
              {imageUrls.cover_images.map((url, index) => (
                <div key={index} className='relative w-40 h-40 mb-5'>
                  <img src={url} alt='' className='w-full h-full object-cover rounded' />
                  <button
                    onClick={() => {
                      const updated = imageUrls.cover_images.filter((_, i) => i !== index);
                      setImageUrls({ ...imageUrls, cover_images: updated });
                    }}
                    className='absolute top-1 right-1 text-xs bg-black bg-opacity-50 text-white rounded px-1'>
                    Remove
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        <div>
          <FileUploader
            key={imageUrls.cover_videos.length}
            maxNumberOfFiles={6}
            token={token}
            fileType='video'
            fileUrls={imageUrls.cover_videos}
            setFileUrls={(cover_videos) => setImageUrls({ ...imageUrls, cover_videos })}
            label={
              <div className='mb-4'>
                <h3 className='font-medium text-[16px]'>Upload Display Videos </h3>
                <p className='text-[10px] text-[#595959] mt-1'> Maximum of 6 videos</p>
              </div>
            }
            isMultiple
            disabled={imageUrls.cover_videos.length >= 6}
            className='mt-5'
            apiUrl='https://file-api.getfoodcourt.com/upload-video'
          />
          {imageUrls.cover_videos.length > 0 && (
            <div className='mt-4 flex flex-wrap gap-3'>
              {imageUrls.cover_videos.map((url, index) => (
                <div
                  key={index}
                  className='w-full max-w-[160px] h-[160px] aspect-video relative group cursor-pointer'>
                  <video src={url} controls className='w-full h-full object-cover rounded' />
                  <button
                    onClick={() => {
                      const updated = imageUrls.cover_videos.filter((_, i) => i !== index);
                      setImageUrls({ ...imageUrls, cover_videos: updated });
                    }}
                    className='absolute top-1 right-1 text-xs bg-black bg-opacity-50 text-white rounded px-1'>
                    Remove
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CokitchenStatus;
